import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_KEY } from './supabaseConfig';

// The supabase-js client. Login.tsx, AppShell and MeSheet authenticate through it.
//
// It used to read VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY with a `?? ''` fallback
// — a DIFFERENT pair of env vars from the ones lib/sandbox.ts reads. That split is a
// trap: point sandbox.ts at the local Docker database and login would still
// authenticate against the hosted project, so every request would carry a JWT signed
// by the wrong secret and RLS would return nothing. An empty app, not an error.
//
// Auth and data must always agree on which database they mean, so both now come from
// supabaseConfig — one source, and it throws rather than guessing.
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: { persistSession: false },
});
